import React from 'react';
import { useDeviceSizeType } from 'src/utils/hooks/useDeviceType';
import { BaseCard } from 'src/components/common';
import { useStyles } from './userPageCardStyles';

export const UserPageCard: React.FC = (props) => {
  const { children } = props;
  const { isTablet } = useDeviceSizeType();
  const classes = useStyles();

  return (
    <BaseCard offCardStyles={!isTablet} className={classes.rootCard}>
      {children}
    </BaseCard>
  );
};
